import "./icon-date-picker.scss";

import EventIcon from "@mui/icons-material/Event";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { DatePicker } from "@mui/x-date-pickers";
import { getFirstDefined } from "verdi-common/utils/getFirstDefined";
import { AddEndingToDate, ShortDayLookup, ShortMonthLookup } from "verdi-common/utils/dateUtils";
import { generateUID } from "verdi-common/utils/HelperFunctions";
import React from "react";
import { isMobile } from "react-device-detect";

import { DateAvatar } from "@/features/schedule-editor/components/date-avatar";

export default function IconDatePicker(props) {
    const [pickerOpen, setPickerOpen] = React.useState(false);
    const [, setDummy] = React.useState(0);
    const uid = React.useMemo(() => generateUID("IconDatePicker"), []);
    const className = "IconDatePicker";
    const selectedTime = getFirstDefined(props.value, props.defaultValue, new Date(Date.now()));
    return (
        <div className={className} id={uid}>
            <IconButton
                onClick={() => {
                    setPickerOpen(true);
                }}
                size={"small"}
            >
                <DateAvatar date={selectedTime} includeYear={props.includeYear} includeTime={props.includeTime} />
            </IconButton>

            <DatePicker
                renderInput={() => null}
                onClose={() => {
                    setPickerOpen(false);
                }}
                open={pickerOpen}
                PopperProps={
                    isMobile
                        ? null
                        : {
                              anchorEl: () => document.getElementById(uid),
                          }
                }
                disableMaskedInput={true}
                style={{ display: "none" }}
                variant={isMobile ? "dialogue" : "inline"}
                margin={"normal"}
                value={selectedTime}
                labelFunc={(date) =>
                    // eslint-disable-next-line new-cap
                    `${ShortDayLookup[date.getDay()]} ${ShortMonthLookup[date.getMonth()]}. ${AddEndingToDate(
                        date.getDate(),
                    )}`
                }
                InputProps={{
                    startAdornment: (
                        <InputAdornment position={"start"}>
                            <EventIcon color={"action"} />
                        </InputAdornment>
                    ),
                }}
                onChange={(date) => {
                    const newStartTime = new Date(selectedTime?.valueOf() ?? 0);
                    newStartTime.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
                    if (props.onChange) {
                        props.onChange(newStartTime);
                    }
                    setDummy(Math.random());
                }}
            />
        </div>
    );
}
